import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'

import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationAutomaticAssayOntologyCreateRequest, ConfigurationAutomaticOntologyAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-automatic-ontology-assay/configuration-automatic-ontology-assay.dto'

class ConfigurationAutomaticOntologyAssayService {
    async create(laboratoryId: number, request: ConfigurationAutomaticAssayOntologyCreateRequest): Promise<ConfigurationAutomaticOntologyAssayResponse> {
        const response = await axios.post<ConfigurationAutomaticOntologyAssayResponse>(`/configuration/laboratories/${laboratoryId}/automaticAssayOntologies`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticOntologyAssayResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticOntologyAssayResponse>>(`/configuration/laboratories/${laboratoryId}/automaticAssayOntologies`, { ...filterModel }, { params })
        return response.data
    }

    async get(laboratoryId: number, automaticAssayOntologyId: number): Promise<ConfigurationAutomaticOntologyAssayResponse[]> {
        const response = await axios.get<ConfigurationAutomaticOntologyAssayResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticAssayOntologies/${automaticAssayOntologyId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticAssayOntologies/batch`, { data: request })
        return response.data
    }
}

export const configurationAutomaticOntologyAssayService = new ConfigurationAutomaticOntologyAssayService()
